import { render, staticRenderFns } from "./base.vue?vue&type=template&id=20208600"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20208600')) {
      api.createRecord('20208600', component.options)
    } else {
      api.reload('20208600', component.options)
    }
    module.hot.accept("./base.vue?vue&type=template&id=20208600", function () {
      api.rerender('20208600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/media-types/base.vue"
export default component.exports